import { useNavigate } from "react-router-dom";
import "./mobile-nav.css";
import OpGuruRoutes from "./OpGuruRoutes.js";
import { useState } from "react";

export default function MobileNav() {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <div>
        <div className="hamburger" onClick={() => setIsOpen(!isOpen)}>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
        <nav className={isOpen ? "mobileMenu isOpen" : "mobileMenu"}>
          <ul>
            {OpGuruRoutes.map((route, key) => {
              const isBookCall = route.name === "Book a Free Call";
              return (
                <li 
                  key={key} 
                  className={isBookCall ? "bookCallItem" : ""}
                  onClick={() => {
                    navigate(`/${route.linkTo}`);
                    setIsOpen(false); // Close menu after navigation
                  }}
                >
                  {route.name}
                </li>
              );
            })}
          </ul>
        </nav>
      </div>
    </>
  );
}